<lxm-dialog [dialogRef]="dialogRef" [formGroup]="form">
  <span header-title>
    {{ itemId ? (translationsPath + ".title" | translate) : (translationsPath + ".title_new" | translate) }}
  </span>

  <div body style="padding-bottom: 40px;">

    <p class="mt10 mb30 font-text font-normal text-dirtyPurple">
      {{ translationsPath + ".info_text" | translate }}
    </p>

    <form-field dialog label="cards.settings.product_management_settings.warehouse_types_edit.label.name" for="value"
      type="input-text" [required]="true">
      <validation-errors for="value"></validation-errors>
    </form-field>

    <form-field dialog label="cards.settings.product_management_settings.warehouse_types_edit.label.allowed_days"
      [required]="true">
      <days-toggle any [formGroup]="form" for="deliveryDays" [readonly]="!appState.hasRights(requiredRightsForEdit)">
      </days-toggle>
    </form-field>

    <form-field dialog label="cards.settings.product_management_settings.warehouse_types_edit.label.min_order_value"
      for="minOrderValue">
      <lxm-input for="minOrderValue" type="price" class="w-full"></lxm-input>
      <validation-errors for="minOrderValue"></validation-errors>
    </form-field>

    <form-field dialog label="cards.settings.product_management_settings.warehouse_types_edit.label.allow_today_delivery"
      [readonly]="!appState.hasRights(requiredRightsForEdit)">
      <slide-toggle toggle for="allowTodayDelivery"
        [readonly]="!appState.hasRights(requiredRightsForEdit)"></slide-toggle>
    </form-field>

    <form-field dialog label="cards.settings.product_management_settings.warehouse_types_edit.label.description"
      description="cards.settings.product_management_settings.warehouse_types_edit.label_description.description"
      for="description" type="textarea" [minRows]="4" [maxlength]="200">
      <validation-errors for="description"></validation-errors>
    </form-field>

    <form-field dialog label="cards.settings.clv.common.table.status" [required]="true">
      <lxm-select select for="status" class="select w40p" [formGroup]="form" [options]="statuses" [clearable]="false"
        value="id">
      </lxm-select>
      <validation-errors for="status"></validation-errors>
    </form-field>
  </div>

  <div footer>
    <lxm-button type="primary" label="action.save" (click)="save()" buttonType="submit" [loading]="saveInProgress"
      *requiredRights="requiredRightsForEdit"></lxm-button>
    <lxm-button type="tertiary" label="action.cancel" (click)="closeDialog()"></lxm-button>
  </div>
</lxm-dialog>